import { useAppSelector } from "../../../redux/hooks";
import type {
  DataViewScope,
  DataViewScopeDefinition,
  DataViewVisibility,
} from "../../../zodios/apiDefinitions/api/dataViews";

export const useBuildScopeDefinition = () => {
  const orgId = useAppSelector((state) => state.user.organization_id);
  const marketplace = useAppSelector((state) => state.marketPlace.marketPlace);
  const accountManagerId = useAppSelector((state) => state.user.account_manager.id);

  return (scope: DataViewScope, visibility: DataViewVisibility): DataViewScopeDefinition => ({
    scope,
    visibility,
    entity_id:
      scope === "ORGANIZATION" ? orgId
      : scope === "MARKETPLACE" ? marketplace
      : String(accountManagerId ?? ""),
  });
};
